import '@calcom/atoms/globals.min.css';
import * as React from 'react';
import { useState } from 'react';
import { noScrollbarCSS } from '@epihub/web/src/components/css';
import { styled } from '../../theme/theme';
import { useSfyr } from '../../_ctx/sfyr';
import { Calendar } from './Calendar';
import { CalendarEventCard } from './CalendarEventCard';

export const CalendarView = () => {
  const sfyr = useSfyr();
  const [eventSlug, setEventSlug] = useState<string>('short-chat');
  return (
    <>
      <CardsContainer>
        {sfyr('ui.{lang}.calendar.events.*', {
          defaults: {
            'ui.{lang=en}.calendar.events.{slug=short-chat}': {
              title: 'Quick Chat',
              description: `
                Use this meeting when you just want to say hello, bounce a quick idea, or confirm that I am, in fact,
                a real human and not an exceptionally well-trained AGI.
              `,
              duration: '15m',
            },
            'ui.{lang=en}.calendar.events.{slug=long-chat}': {
              title: 'Long Chat',
              description: `
                Use this meeting when you have a project to dissect, a problem to solve, or enough questions to make a 
                podcast episode. Coffee recommended, tea banned.
              `,
              duration: '15m',
            },
            'ui.{lang=it}.calendar.events.{slug=short-chat}': {
              title: 'Chiacchierata',
              description: `
                Usa questa riunione quando vuoi semplicemente dire ciao, condividere un'idea veloce o confermare che sono, 
                in effetti, un essere umano reale e non un'AGI eccezionalmente ben addestrata.
              `,
              duration: '15m',
            },
            'ui.{lang=it}.calendar.events.{slug=long-chat}': {
              title: 'Conversazione Lunga',
              description: `
                Usa questo incontro quando hai un progetto da analizzare, un problema da risolvere o abbastanza domande 
                per fare un episodio di podcast. Caffè consigliato, tè vietato.
              `,
              duration: '15m',
            },
          },
        }).map(([slug, eventData]) => (
          <CalendarEventCard
            key={slug}
            eventSlug={slug}
            eventData={eventData}
            isSelected={slug === eventSlug}
            onClick={setEventSlug}
          />
        ))}
      </CardsContainer>
      <CalendarContainer>
        <Calendar eventSlug={eventSlug} />
      </CalendarContainer>
    </>
  );
};

const CardsContainer = styled.div`
  ${noScrollbarCSS};
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  margin-top: 24px;
  padding-top: 24px;
  overflow: visible;

  @media (min-width: 769px) {
    flex-direction: row;
    gap: 24px;
    margin-top: 48px;
    padding-top: 0;
  }
`;

const CalendarContainer = styled.div`
  margin-top: 48px;

  @media (min-width: 769px) {
    margin-top: 96px;
  }
`;
